import { Link } from 'react-router-dom';
import {Button, Table, Spin, Modal} from 'antd';
import Header from '../../../components/HeaderList';
import {ReactComponent as Edit} from '../../../assets/icons/edit.svg';
import {getColumnSearchProps} from '../../../utils/tables';
import Editor from './Editor';
import styles from '../styles/ZonesUI.module.css';


const ZonesUI = props => {
  const {
    loading,
    zone,
    branches,
    editorVisible,
    closeEditor,
    departments,
    levels,
    handleZone,
  } = props;

  const BranchColumns = [
    {
      title: "Sucursal",
      dataIndex: "zone",
      ...getColumnSearchProps("name"),
    },
    {
      title: "Dirección",
      dataIndex: "address",
    },
    {
      title: "punto GPS",
      dataIndex: "id",
      align: "center",
      render: (id, record) => (
        <div className={styles.actions}>[{record.latitude}, {record.longitude}]</div>
      )
    },
    
    
    {
      title: "ver Cobertura",
      align: "center",
      dataIndex: "id",
      render: (id, record) => (
        <div className={styles.actions}>
          <Link className={styles.edit} to={`/ajustes/zonas/edit/${id}`}>
            <Edit />
          </Link>
        </div>
      ),
    },
  ];

  return (
    <div className={styles.view}>
      <Header
        title="Coberturas"
        actions={
          <Link className={styles.edit} to={`/ajustes/zonas/listado`}>
            <Button
              type="primary"
              size="large"
              className="main-button">
              IR A ZONAS
            </Button>
        </Link>
        }
      />

    {/*    <Button
          onClick={newZone}
          type="primary"
          size="large"
          className="main-button">
          NUEVA COBERTURA
        </Button> 
         */}
      {loading ? (
        <div className={styles.loader}>
          <Spin size="large" />
        </div>
      ) : (
        <div>
          <Table
            columns={BranchColumns}
            dataSource={branches}
            rowKey="id"
          />
        </div>
      )}
      <Modal
        destroyOnClose
        closable={false}
        visible={editorVisible}
        footer={false}
        onCancel={closeEditor}
        width={600}
      >
        <Editor
          close={closeEditor}
          zone={zone}
          departments={departments}
          levels={levels}
          branches={branches}
          handleZone={handleZone}
        />
      </Modal>
    </div>
  );
};

export default ZonesUI;
